import { h } from '@stencil/core';
import { isPBS } from '@pes-ui/utils';
import { MAX_RANGES_BEFORE_SDL_PROMO_BANNER, MAX_VISIBLE_CARDS_WHILE_COLLAPSED, } from '../constants';
import { SubcategoryBlockUI } from './subcategory-block-ui';
export class SubcategoryBlock {
  constructor() {
    this.toggleRangeBlock = (e) => {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      this.rangeBlockCollapsed = !this.rangeBlockCollapsed;
    };
    this.getRangeRenderer = (range, idx) => () => (h("pes-category-range-card", { key: range.id, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, subCategory: !this.shouldHaveSubcategory && this.subCategory, class: "subcategory-block__range-card", data: range, productRelationsViewProdLabel: this.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: this.rangeProductsViewDetailsLabel, viewOnLabel: this.viewOnLabel, rangePartofLabel: this.rangePartofLabel, avoidAccents: this.avoidAccents, withImageLazy: this.isFirstBlock ? idx > 2 : true }));
    this.promoBannerRenderer = () => (h("pes-banner-promo-block", { key: "subcategory-promo-banner", class: "subcategory-block__promo-banner", sdlCategoryPromo: this.subCategory.sdlCategoryPromo }));
    this.subCategory = undefined;
    this.rangePartofLabel = undefined;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.rangesSectionTitleLabel = undefined;
    this.viewMoreLabel = undefined;
    this.viewLessLabel = undefined;
    this.rangeBlockCollapsible = undefined;
    this.showDescriptionBlock = true;
    this.avoidAccents = undefined;
    this.navState = undefined;
    this.rangeBlockCollapsed = undefined;
    this.isFirstBlock = false;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.shouldHaveSubcategory = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.rangeBlockCollapsed = this.rangeBlockCollapsible;
  }
  watchRangeBlockCollapsible(newValue) {
    if (newValue === this.rangeBlockCollapsed)
      return;
    this.rangeBlockCollapsed = newValue;
  }
  render() {
    var _a, _b;
    if (!((_b = (_a = this.subCategory) === null || _a === void 0 ? void 0 : _a.ranges) === null || _b === void 0 ? void 0 : _b.length))
      return;
    const allCardsRenderers = this.subCategory.ranges.map(this.getRangeRenderer);
    if (!isPBS() && this.subCategory.sdlCategoryPromo) {
      allCardsRenderers.splice(MAX_RANGES_BEFORE_SDL_PROMO_BANNER, 0, this.promoBannerRenderer);
    }
    const visibleCardsRenderers = this.rangeBlockCollapsed
      ? allCardsRenderers.slice(0, MAX_VISIBLE_CARDS_WHILE_COLLAPSED)
      : allCardsRenderers;
    const shouldDescriptionBeVisible = this.showDescriptionBlock
      && (this.subCategory.name || this.subCategory.description);
    return (h(SubcategoryBlockUI, { shouldDescriptionBeVisible: Boolean(shouldDescriptionBeVisible), visibleCardsRenderers: visibleCardsRenderers, subCategory: this.subCategory, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, rangesSectionTitleLabel: this.rangesSectionTitleLabel, rangeBlockCollapsible: this.rangeBlockCollapsible, allCardsRenderers: allCardsRenderers, rangeBlockCollapsed: this.rangeBlockCollapsed, viewMoreLabel: this.viewMoreLabel, viewLessLabel: this.viewLessLabel, toggleRangeBlock: this.toggleRangeBlock, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName }));
  }
  static get is() { return "pes-subcategory-block"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["subcategory-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["subcategory-block.css"]
    };
  }
  static get properties() {
    return {
      "subCategory": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSubCategory",
          "resolved": "{ id: string; name: string; description?: string; badge?: TProductBadge; url?: string; ranges: TRange[]; sdlCategoryPromo?: TSDLPromoBlock; }",
          "references": {
            "TSubCategory": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "subcategory"
        }
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Part of #MasterRangeName#\""
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View on #domain_name#\""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View products\""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View details\""
        },
        "attribute": "range-products-view-details-label",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read more\""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read less\""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "rangesSectionTitleLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Label for \"Browse by ranges\""
        },
        "attribute": "ranges-section-title-label",
        "reflect": false
      },
      "viewMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Label for \"View more\""
        },
        "attribute": "view-more-label",
        "reflect": false
      },
      "viewLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Label for \"View less\""
        },
        "attribute": "view-less-label",
        "reflect": false
      },
      "rangeBlockCollapsible": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Flag controlling availability of \"View more/View less\" block"
        },
        "attribute": "range-block-collapsible",
        "reflect": false
      },
      "showDescriptionBlock": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Visibility of subcategory description block"
        },
        "attribute": "show-description-block",
        "reflect": false,
        "defaultValue": "true"
      },
      "avoidAccents": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Styling title and description of range-card"
        },
        "attribute": "avoid-accents",
        "reflect": false
      },
      "navState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "nav-state",
        "reflect": false
      },
      "isFirstBlock": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "To apply loading = \"lazy | eager\" for card image"
        },
        "attribute": "is-first-block",
        "reflect": false,
        "defaultValue": "false"
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "shouldHaveSubcategory": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "define is it subcategory page"
        },
        "attribute": "should-have-subcategory",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "rangeBlockCollapsed": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "rangeBlockCollapsible",
        "methodName": "watchRangeBlockCollapsible"
      }];
  }
}
